module.exports = __webpack_public_path__ + "img/rewind.64f59077.svg";